/* eslint-disable */
// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.
// If you need to update this file, make changes in the Core application
// then run `import:api` in your terminal from the root of this project.
import { AxiosPromise } from 'axios';

import { baseClientConstructorProps } from 'app/api/apiClient/config';

import { BaseClient, BaseClientConstructorProps, QueryParams, SendRequestPayload } from '../baseClient';
import { 
  CorePayeePaymentsSearchPaymentsParams,
  CorePayeePaymentsGetPaymentParams,
  CorePayeePaymentsGetPaymentImagesParams,
  SearchPaymentsResponse,
  GetPaymentResponse,
  GetPaymentImagesResponse,
  GetStatusesResponse
 } from '../types';

  //  CorePayeePaymentsClient
class CorePayeePaymentsClient extends BaseClient {
    constructor(props: BaseClientConstructorProps) {
        super(props);
    }

    readonly searchPayments = (queryParams: CorePayeePaymentsSearchPaymentsParams): AxiosPromise<SearchPaymentsResponse> => {
        let url_ = "/api/v1/core/payee/payments";

        const qParams = { ...queryParams };
        const hasExportReport = "exportReport" in qParams && qParams.exportReport;
        if (hasExportReport) {
            if ("page" in qParams) {
                delete qParams.page;
            }
            if ("pageSize" in qParams) {
                delete qParams.pageSize;
            }
        }

        const sendRequestPayload: SendRequestPayload = {
            responseType: hasExportReport ? "blob" : undefined,
            queryParams: qParams as unknown as QueryParams,
            method: "GET",
            endpoint: url_,
        };

        return this._sendRequest(sendRequestPayload);
    }

    readonly getPayment = (id: string, queryParams: CorePayeePaymentsGetPaymentParams): AxiosPromise<GetPaymentResponse> => {
        let url_ = "/api/v1/core/payee/payments/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));

        const qParams = { ...queryParams };
        const hasExportReport = "exportReport" in qParams && qParams.exportReport;
        if (hasExportReport) {
            if ("page" in qParams) {
                delete qParams.page;
            }
            if ("pageSize" in qParams) {
                delete qParams.pageSize;
            }
        }

        const sendRequestPayload: SendRequestPayload = {
            responseType: hasExportReport ? "blob" : undefined,
            queryParams: qParams as unknown as QueryParams,
            method: "GET",
            endpoint: url_,
        };

        return this._sendRequest(sendRequestPayload);
    }

    readonly getPaymentImages = (id: string, queryParams: CorePayeePaymentsGetPaymentImagesParams): AxiosPromise<GetPaymentImagesResponse> => {
        let url_ = "/api/v1/core/payee/payments/{id}/full_images";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));

        const qParams = { ...queryParams };
        const hasExportReport = "exportReport" in qParams && qParams.exportReport;
        if (hasExportReport) {
            if ("page" in qParams) {
                delete qParams.page;
            }
            if ("pageSize" in qParams) {
                delete qParams.pageSize;
            }
        }

        const sendRequestPayload: SendRequestPayload = {
            responseType: hasExportReport ? "blob" : undefined,
            queryParams: qParams as unknown as QueryParams,
            method: "GET",
            endpoint: url_,
        };

        return this._sendRequest(sendRequestPayload);
    }

    readonly getStatuses = (): AxiosPromise<GetStatusesResponse> => {
        let url_ = "/api/v1/core/payee/payments/statuses";

        const sendRequestPayload: SendRequestPayload = {
            method: "GET",
            endpoint: url_,
        };

        return this._sendRequest(sendRequestPayload);
    }
}
// CorePayeePaymentsClient
  
export const corePayeePaymentsClient = new CorePayeePaymentsClient(baseClientConstructorProps);
